"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MomentPreviewCell = void 0;

var _react = _interopRequireDefault(require("react"));

var _ = require("../..");

var _atoms = require("../../atoms");

var _GameSummary = require("../../molecules/GameSummary");

var _MomentPreview = require("../MomentPreview");

require("./MomentPreviewCell.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var MomentPreviewCell = function MomentPreviewCell(props) {
  var clipItem = props.moment;

  var _onClick = function onClick(e) {
    if (e) e.preventDefault();
    var clipItem = props.moment;
    var link = "".concat(process.env.REACT_APP_GO_TRACEUP, "/#/").concat(clipItem.meta.home_team.id, "/games/").concat(clipItem.game_id, "/").concat(clipItem.playlist_type, "/C").concat(clipItem.game_clip_id);
    (0, _.trackEvent)({
      action: "MomentPreview:Open Game Clicked:Game:".concat(clipItem.game_id),
      element: e === null || e === void 0 ? void 0 : e.currentTarget
    });
    Object.assign(document.createElement("a"), {
      target: "_blank",
      href: link
    }).click();
  }; // Combine the parent event with its sources into a single list


  var allMomentSources = clipItem !== null && clipItem !== void 0 && clipItem.sources ? [clipItem].concat(_toConsumableArray(clipItem.sources)) : [clipItem];
  return /*#__PURE__*/_react.default.createElement(_atoms.Element, {
    className: "moment-preview-cell-content"
  }, /*#__PURE__*/_react.default.createElement(_atoms.Element, {
    className: "preview"
  }, /*#__PURE__*/_react.default.createElement(_atoms.Element, {
    className: "video-preview"
  }, /*#__PURE__*/_react.default.createElement(_MomentPreview.MomentPreview, {
    event: clipItem,
    sources: allMomentSources,
    playbackRate: 2,
    onClick: function onClick(e) {
      return _onClick(e);
    },
    index: props.index,
    onVisibilityChange: props.onVisibilityChange,
    utmCampaign: props.utmCampaign
  }))), /*#__PURE__*/_react.default.createElement(_GameSummary.GameSummary, {
    homeTeamStyle: clipItem.meta.home_team.color_value,
    homeTeamName: clipItem.meta.home_team.name,
    homeTeamScore: clipItem.meta.home_team.score,
    awayTeamStyle: clipItem.meta.away_team.color_value,
    awayTeamName: clipItem.meta.away_team.name,
    awayTeamScore: clipItem.meta.away_team.score
  }));
};

exports.MomentPreviewCell = MomentPreviewCell;